import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import useProtecaoDeRota from '../hooks/useProtecaoDeRota';
import { Spin, message } from 'antd';
import TabelaDados from '../componentes/Table';
import useApi from '../hooks/useApi';
import ModalDelete from '../componentes/modal/DeleteDashboard';
import ModalAdd from '../componentes/modal/AddDashboard';
import ModalEdit from '../componentes/modal/EditarDashboard';

const PaginaDashboard = () => {
  const verificando = useProtecaoDeRota();
  const [dashboards, setDashboards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const previousDashboardsRef = useRef([]);  // Ref para armazenar dados anteriores

  const { callApi } = useApi('https://vision.alfama.com/api/view/dashboards', { 
    includeToken: true,
  });

  const extraColumns = useMemo(() => [
    { id: 'nome', name: 'Nome', sort: true, width: '10%' },
    { id: 'descricao', name: 'Descrição', sort: false, width: '5%' },
    { id: 'has_rls', name: 'RLS', sort: true, width: '5%' },
    { id: 'departamento', name: 'Departamento', sort: true, width: '10%' },
    { id: 'homologado', name: 'Homologado', sort: true, width: '5%' },
  ], []);

  const showMessage = useCallback((type, content) => {
    message[type](content);
  }, []);

  const formatarDashboards = useCallback((dashboards) => {
    return dashboards.map(dashboard => ({
      id: dashboard.dashboard_id,
      nome: dashboard.nome_dashboard,
      descricao: dashboard.descricao_dashboard,
      has_rls: dashboard.has_rls,
      has_rls_id: dashboard.has_rls_id,
      departamento: dashboard.nome_departamento,
      departamento_id: dashboard.departamento_id,
      workspace_id: dashboard.workspace_id,
      report_id: dashboard.report_id,
      homologado: dashboard.is_homologado_status,
      homologado_id: dashboard.is_homologado ,
      data_criacao: dashboard.dashboard_data_criacao,
      data_atualizacao: dashboard.dashboard_data_atualizacao,
      status: dashboard.situacao_dashboard,
    }));
  }, []);
  
  const buscarDashboards = useCallback(async () => {
    try {
      const resultado = await callApi();
      const dashboardsFormatados = formatarDashboards(resultado);

      if (JSON.stringify(dashboardsFormatados) !== JSON.stringify(previousDashboardsRef.current)) {
        setDashboards(dashboardsFormatados);
        previousDashboardsRef.current = dashboardsFormatados;
      }
    } catch (erro) {
      console.error('Erro ao buscar dashboards:', erro);
      showMessage('error', 'Não foi possível carregar os dashboards');
    } finally {
      setIsLoading(false);
    }
  }, [callApi, formatarDashboards, showMessage]);

  const handleModalOpen = useCallback((type, id) => {
    setModalType(type);
    setSelectedId(id);
    setModalVisible(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
    setModalType(null);
    setSelectedId(null);
    buscarDashboards();
  }, [buscarDashboards]);

  const handleDeleteConfirm = useCallback(async (success) => {
    if (success) {
      await buscarDashboards();
    }
    handleModalClose();
  }, [buscarDashboards, handleModalClose]);

  const handleEditConfirm = useCallback(async (success) => {
    if (success) {
      await buscarDashboards();
    }
    handleModalClose();
  }, [buscarDashboards, handleModalClose]);

  const handleAddConfirm = useCallback(async (success) => {
    if (success) {
      await buscarDashboards();
    }
    handleModalClose();
  }, [buscarDashboards, handleModalClose]);

  const getSelectedDashboard = useCallback((id) => {
    return dashboards.find(dash => dash.id === id) || {};
  }, [dashboards]);

  useEffect(() => {
    if (!verificando) {
      buscarDashboards();
    }

    const intervalId = setInterval(() => {
      buscarDashboards();
    }, 300000);

    return () => {
      clearInterval(intervalId);
    };
  }, [buscarDashboards, verificando]);



  return (
    <>
      <TabelaDados 
        data={dashboards} 
        extraColumns={extraColumns}
        onModalOpen={handleModalOpen}
      />

      {modalType === 'delete' && (
        <ModalDelete
          visible={modalVisible}
          id={selectedId}
          onCancel={handleModalClose}
          onConfirm={handleDeleteConfirm}
        />
      )}

      {modalType === 'edit' && (
        <ModalEdit
          visible={modalVisible}
          id={selectedId}
          initialData={getSelectedDashboard(selectedId)}
          onCancel={handleModalClose}
          onConfirm={handleEditConfirm}
        />
      )}

      {modalType === 'add' && (
        <ModalAdd
          visible={modalVisible}
          onCancel={handleModalClose}
          onConfirm={handleAddConfirm}
        />
      )}
    </>
  );
};

export default PaginaDashboard;